export const CALCULATION_METHODS_DATA = [
    {
        name: "Universal Average",
        description:
            "Average of all available data points for the collector in the current year. If no current-year data is available, the average from the previous year is used.",
    },
] as const;

export const CALCULATION_METHODS_OPTIONS = CALCULATION_METHODS_DATA.map((method) => ({
    label: method.name,
    value: method.name,
}));

export const FILL_GAPS_MODAL_DATA = {
    title: "Data Filling using Extrapolation",
    getDescription: (count: number) =>
        `This action will apply to ${count} selected collectors. All days with missing usage data within the selected date range will be filled using extrapolation. Any existing extrapolated values within this date range will also be refreshed using the latest available data. Existing data from uploaded bills or Excel files will remain unchanged.`,
};

export const REFRESH_EXTRAPOLATION_MODAL_DATA = {
    title: "Refresh Extrapolation",
    getDescription: (count: number) =>
        `This action will apply to ${count} selected collectors and will recalculate previously extrapolated values using the most up-to-date available data. All days with extrapolated data within the selected date range will be refreshed. Existing data from uploaded bills or Excel files will remain unchanged.`,
};
